/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edit/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import Note from './Note/index'
import React from 'react'
import Users from './Users/index'
import VisibleInSchedule from './VisibleInSchedule/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Edit({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Edit"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Edit.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Edit.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-9u9G': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Users
  viewPath={`${viewPath}/Users`}
/>
<VisibleInSchedule
  viewPath={`${viewPath}/VisibleInSchedule`}
/>
</div>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
<Note
  viewPath={`${viewPath}/Note`}
/>
{children}
</React.Fragment>)
}